var map = {
	"./icon_branch.js": 21,
	"./icon_branch.js.es6": 21,
	"./icon_build_status.js": 22,
	"./icon_build_status.js.es6": 22,
	"./icon_commit.js": 23,
	"./icon_commit.js.es6": 23
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 166;


//////////////////
// WEBPACK FOOTER
// ./cycle_analytics/svg nonrecursive ^\.\/.*\.(js|es6)$
// module id = 166
// module chunks = 2